<template>
<div class="width-100 mdc-textfield mdc-textfield--upgraded">
	<input class="mdc-textfield__input" ref="input" type="tel" :value="value" @input="updateValue($event.target.value)" inputmode="numeric" pattern="[0-9+]*" :placeholder="placeholder" :class="{'input--focus' : value !== '', 'input--focus-warn': value == '' || value == undefined}">
	<label for="autocomplete" class="mdc-textfield__label mdc-textfield__label--float-above">{{label}}</label>
	<a v-if="!isEmpty" href="#" class="input__closebtn" @click.prevent="clear"><i class="ico-delete"></i></a>
</div>
</template>

<script>
import Inputmask from "inputmask";

export default {
	props: {
		value: [String, Number],
		placeholder: String,
		label: {
			type: String,
			default: 'Price'
		}
	},
	computed: {
		isEmpty: function(){
			return this.value == '' || this.value === undefined ||  isNaN(this.value) || this.value === '0';
		}
	},
	mounted: function() {
		Inputmask({
			alias: "numeric",
			groupSeparator: ',',
			autoGroup: true,
			digits: 0,
			prefix: '£',
			autoUnmask: true,
			unmaskAsNumber: true,
			rightAlign: false,
			positionCaretOnClick: 'none'
		}).mask(this.$refs.input);
	},
	methods: {
		updateValue: function(value) {
			this.$emit('newValue', value);
		},
		clear: function() {
			this.$refs.input.value = '';
			this.$refs.input.focus();
			this.updateValue();
		}
	},
	watch: {
	}
}
</script>



// WEBPACK FOOTER //
// src/components/CurrencyInput.vue